import React from "react";
import { FunctionComponent } from "react";

const NotFoundPage: FunctionComponent = () => {
  return (<div>Page introuvable</div>);
}

export default NotFoundPage;